// extracted by mini-css-extract-plugin
module.exports = {"root":"IntervalsPerDayBlock_root__3jCB1","ignoreDailySlots":"IntervalsPerDayBlock_ignoreDailySlots__VAEOD"};